/**
 * VAT Toggle Component
 *
 * Pill-style toggle switch matching the qala-vat-switcher plugin design.
 * Checkbox unchecked = exkl. moms, checked = inkl. moms.
 *
 * @package
 */

import PropTypes from 'prop-types';
import { __ } from '@wordpress/i18n';

const VatToggle = ( { vatMode, onToggle } ) => {
	const isIncluding = vatMode === 'including';

	return (
		<div className="configurator-vat-switcher-container">
			<label className="configurator-vat-toggle" htmlFor="configurator-vat-incl-excl">
				<span className="configurator-vat-toggle-label">
					{ __( 'exkl. moms', 'at-vehicle-configurator' ) }
				</span>
				<input
					id="configurator-vat-incl-excl"
					name="vat-incl-excl"
					type="checkbox"
					className="configurator-vat-toggle-checkbox"
					checked={ isIncluding }
					onChange={ e => onToggle( e.target.checked ? 'including' : 'excluding' ) }
				/>
				<span className="configurator-vat-toggle-switch" aria-hidden="true" />
				<span className="configurator-vat-toggle-label">
					{ __( 'inkl. moms', 'at-vehicle-configurator' ) }
				</span>
			</label>
		</div>
	);
};

VatToggle.propTypes = {
	vatMode: PropTypes.oneOf( [ 'including', 'excluding' ] ).isRequired,
	onToggle: PropTypes.func.isRequired,
};

export default VatToggle;
